// extracted by mini-css-extract-plugin
export default {"label":"Checkbox_label__1kKNi","checkbox":"Checkbox_checkbox__e9as9","customCheckbox":"Checkbox_customCheckbox__oMmy3"};